/* eslint-disable no-unused-vars */
import { Grid, useTheme } from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Button from "../../components/Button";
import Pagination from "../../components/Pagination";
import Search from "../../components/Search";
import {
  getQuizzesList,
  setQuizzesBookFilter,
  setQuizzesPage
} from "../../store/Quizzes/actions";
import QuizzesList from "./QuizzesList";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AddIcon from "@material-ui/icons/Add";
import { ROUTE_PATHS } from "../../utils/PathsNames";
import AssignQuiz from "./AssignQuiz";
import messages from "../../assets/locale/messages";
import DeleteQuiz from "./DeleteQuiz";
import EmptyState from "../../components/EmptyState";
import CustomSelect from "../../components/Select";
import { ASC } from "../../utils/Constants";
import { getBooksRequest } from "../../store/Books/actions";
import styles from "./Quizzes.module.scss";
import Title_Section from "../../components/Title_Section/Title_Section";
const Quizzes = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector((state) => state.loader);

  const {
    locale: { lang },
    quizzes: {
      list,
      meta,
      assignQuizBtn,
      deleteQuizBtn,
      quizzesPage,
      quizzesBookFilter,
      quizzesBookSort
    }
  } = useSelector((state) => state);

  const {
    quizzes,
    inputs: { filterByBook }
  } = messages[lang];

  const theme = useTheme();
  useEffect(() => {
    const params = {
      page: quizzesPage,
      title: search,
      items: 10,
      book_id: quizzesBookFilter,
      sort_by_book_page: !!quizzesBookSort,
      sort_method: quizzesBookSort
    };
    if (!quizzesBookFilter) {
      delete params.book_id;
      delete params.sort_by_book_page;
      delete params.sort_method;
    }
    if (!quizzesBookSort) {
      delete params.sort_by_book_page;
      delete params.sort_method;
    }
    dispatch(getQuizzesList(params));
  }, [search, quizzesPage, quizzesBookSort, quizzesBookFilter]);

  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(setQuizzesPage({ page }));
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleAddQuiz = () => {
    history.push(`${ROUTE_PATHS["addQuiz"]}`);
  };
  // filter
  const booksList = useSelector((state) => state.books.list);
  const [booksOptions, setBooksOptions] = useState([]);
  useEffect(() => {
    dispatch(getBooksRequest({ lookup: true }));
  }, []);
  useEffect(() => {
    if (booksList.length) {
      setBooksOptions([
        { id: 0, value: 0, label: "No Filter" },
        ...booksList.map(({ id, title }) => ({
          id,
          value: id,
          label: title
        }))
      ]);
    }
  }, [booksList]);
  const handleSelectedBookFilter = (id) => {
    if (id) {
      dispatch(
        getQuizzesList({
          page: quizzesPage,
          title: search,
          items: 10,
          book_id: id,
          sort_by_book_page: true,
          sort_method: ASC
        })
      );
      dispatch(setQuizzesBookFilter({ id }));
    } else {
      dispatch(
        getQuizzesList({
          page: quizzesPage,
          title: search,
          items: 10
        })
      );
      dispatch(setQuizzesBookFilter({ id: 0 }));
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={quizzes.quizzes} />
      </div>
      <Grid
        style={{ display: "flex", gap: "2px", marginBottom: "5px" }}
      >
        <Grid item md={8}>
          <Formik
            initialValues={{ search: "" }}
            onSubmit={handleSearch}
          >
            {() => (
              <Form
                style={{
                  display: "flex",
                  gap: "10px"
                }}
              >
                <Search
                  name="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
                <CustomSelect
                  options={booksOptions}
                  placeholder={filterByBook}
                  name="book_id"
                  style={{ width: "50%" }}
                  isRequired={false}
                  isMenuRelative={false}
                  handleSelectChange={(id) => {
                    handleSelectedBookFilter(id);
                  }}
                />
              </Form>
            )}
          </Formik>
        </Grid>
        <Grid
          item
          md={4}
          className="d-flex align-items-start gap-1 justify-content-end"
        >
          <Button
            text={"add Quiz"}
            icon={<AddIcon className="mx-2" />}
            onClick={handleAddQuiz}
          />
          <Button
            text={"Import Quizzes"}
            icon={<AddIcon className="mx-2" />}
            onClick={() =>
              history.push(`${ROUTE_PATHS.importQuizzes}`)
            }
          />
        </Grid>
      </Grid>
      <QuizzesList lang={lang} list={list} />
      {!isLoading && !list.length && <EmptyState />}
      {meta.pages > 1 && (
        <div className={styles.footerDiv}>
          <div className={styles.PageNumberDiv}>
            <label htmlFor="pageInput">Page Number&nbsp;</label>
            <input
              id="pageInput"
              value={page}
              className={styles.InputPage}
              type="number"
              onWheel={(e) => e.target.blur()}
              onChange={(e) => setPage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  dispatch(setQuizzesPage({ page: Number(page) }));
                }
              }}
            />
            <button
              className={styles.ArrowButton}
              onClick={() =>
                dispatch(setQuizzesPage({ page: Number(page) }))
              }
              title="Go To Page"
            >
              <ArrowForwardIcon className="mx-2" />
            </button>
          </div>
          <Pagination
            count={meta?.pages}
            page={quizzesPage}
            defaultPage={quizzesPage}
            handleChange={handlePagination}
          />
        </div>
      )}
      <AssignQuiz isOpen={Boolean(assignQuizBtn)} />
      <DeleteQuiz isOpen={Boolean(deleteQuizBtn)} lang={lang} />
    </div>
  );
};

export default Quizzes;
